import React, { useContext, useState } from "react";
import { saveAs } from "file-saver";
import { CustomToast } from "../../../shared/components/alert/custom-toast";
import { HELPER } from "../../../shared/helper/helper";
import moment from "moment";
import { Optional } from "../../../shared/components/optional/optional";
// import { DownloadProgress } from "../../../shared/components/download-progress/download-progress";
import { MainContext } from "../../../../App";
import { FRONTOFFICE_SERVICE } from "../../../core/services/frontoffice-service";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";

export function DisputeCreationResultDownload(props) {
  const mainContext = useContext(MainContext);
  const [loading, setLoading] = useState(false);
  const [downloadError, setDownloadError] = useState(null);

  function download() {
    const currentDate = Date.now();
    setLoading(true);
    const payload = HELPER.TO_URL_STRING({
      batchId: props.batchId,
    });
    FRONTOFFICE_SERVICE.DOWNLOAD_BULK_DISPUTE_RESPONSE_TRANSACTIONS(
      payload,
      mainContext
    )
      .then((data) => {
        saveAs(
          data,
          `${props.batchId}-${moment(currentDate).format("YYYY-MM-DD")}.xlsx`
        );
        props.closeModal();
      })
      .catch((error) => {
        handleError(error);
      });
  }

  async function handleError(error) {
    const errMessage = await HELPER.PARSE_BLOB_ERROR(error);
    setDownloadError(errMessage);
    resetError();
    setLoading(false);
  }

  function resetError() {
    setTimeout(() => {
      setDownloadError(null);
    }, 5000);
  }

  return (
    <div>
      <div className="p-pb-1">
        {downloadError && (
          <CustomToast title="Error" description={downloadError} type="error" />
        )}
      </div>
      <h4 className="p-text-left p-mt-0">Confirm Download</h4>
      <p className="p-text-left">
        Confirm that you want to download these transactions.
      </p>
      <Optional show={loading}>
        {/* <DownloadProgress /> */}
        <CustomLoader loadingText="Loading..." />
      </Optional>
      <Optional show={!loading}>
        <div className="p-mt-4 p-pb-2">
          <div className="p-grid">
            <div className="p-col-6">
              <button onClick={props.closeModal} className="secondary-button">
                Cancel
              </button>
            </div>
            <div className="p-col-6">
              <button onClick={download} className="primary-button">
                Download
              </button>
            </div>
          </div>
        </div>
      </Optional>
    </div>
  );
}
